import { FilterElement } from "@dashboard/components/Filter";
import { CustomerFilterInput } from "@dashboard/graphql";
import {
  VendorFilterKeys,
  VendorListFilterOpts,
} from "@dashboard/vendors/components/VendorListPage";

import {
  createFilterTabUtils,
  createFilterUtils,
  getGteLteVariables,
  getMinMaxQueryParam,
} from "../../../utils/filters";
import {
  VendorListUrlFilters,
  VendorListUrlFiltersEnum,
  VendorListUrlQueryParams,
} from "../../urls";

export const VENDOR_FILTERS_KEY = "vendorFilters";

export function getFilterOpts(params: VendorListUrlFilters): VendorListFilterOpts {
  return {
    joined: {
      active: [params.joinedFrom, params.joinedTo].some(field => field !== undefined) ?? false,
      value: {
        max: params.joinedTo ?? "",
        min: params.joinedFrom ?? "",
      },
    },
    numberOfOrders: {
      active:
        [params.numberOfOrdersFrom, params.numberOfOrdersTo].some(field => field !== undefined) ??
        false,
      value: {
        max: params.numberOfOrdersTo ?? "",
        min: params.numberOfOrdersFrom ?? "",
      },
    },
  };
}

export function getFilterVariables(params: VendorListUrlFilters): CustomerFilterInput {
  const dateJoined = getGteLteVariables({
    gte: params.joinedFrom,
    lte: params.joinedTo,
  });
  const numberOfOrders = getGteLteVariables({
    gte: params?.numberOfOrdersFrom ? parseInt(params.numberOfOrdersFrom, 10) : null,
    lte: params?.numberOfOrdersTo ? parseInt(params.numberOfOrdersTo, 10) : null,
  });

  // Always include metadata filter for vendors
  const metadata = [
    {
      key: "isVendor",
      value: "true"
    }
  ];

  // Build filter object, only including non-null values
  const filter: CustomerFilterInput = { metadata };
  
  if (dateJoined) {
    filter.dateJoined = dateJoined;
  }
  
  if (numberOfOrders) {
    filter.numberOfOrders = numberOfOrders;
  }
  
  if (params.query) {
    filter.search = params.query;
  }

  return filter;
}

export function getFilterQueryParam(
  filter: FilterElement<VendorFilterKeys>,
): VendorListUrlFilters {
  const { name } = filter;

  switch (name) {
    case VendorFilterKeys.joined:
      return getMinMaxQueryParam(
        filter,
        VendorListUrlFiltersEnum.joinedFrom,
        VendorListUrlFiltersEnum.joinedTo,
      );

    case VendorFilterKeys.numberOfOrders:
      return getMinMaxQueryParam(
        filter,
        VendorListUrlFiltersEnum.numberOfOrdersFrom,
        VendorListUrlFiltersEnum.numberOfOrdersTo,
      );
  }
}

export const storageUtils = createFilterTabUtils<string>(VENDOR_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters, getFiltersCurrentTab } = createFilterUtils<
  VendorListUrlQueryParams,
  VendorListUrlFilters
>(VendorListUrlFiltersEnum);